import React, { Component } from "react";
import "./EligibilityCheck.css";
import { Redirect, Link } from "react-router-dom";
import {
  Card,
  Row,
  Col,
  Spin,
  Button,
  Input,
  Table,
  DatePicker,
  notification,
  Modal,
} from "antd";
import { Form } from "@ant-design/compatible";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
// import Config from '../../config';
// import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import { InfoCircleTwoTone } from '@ant-design/icons';
import search from "../images/Search.svg";
import clear from "../images/clear.svg";
import blackscreen from "../images/emptysearchscreen.svg";
import nodata from "../images/NoData.svg";
import skills from "../images/skills.png";
import Config from "../../config";
import moment from "moment";
import MemberTable from "./eligibilityTable";
import dayjs from 'dayjs';
import WelcomePopup from "./Welcomepopup";

class EligibilityCheck extends Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: [],

      filters: {},

      search: {},

      headers: [],

      isModalVisible: false,

      cardstate: true,

      currState: false,

      Geticon: false,

      clicked: false,

      loader: false,

      Dummytable: [],
      pendingtext:"",

      sort: {
        column: null,

        direction: "asc",
      },
    };
  }

  // Searching Member based on search result.
  SearchEpisode = (event) => {
    event.preventDefault();
    this.setState({ Dummytable: [] });

    let MBI =
      this.props.form.getFieldValue("MBI") == undefined ||
      this.props.form.getFieldValue("MBI") == null
        ? 0
        : this.props.form.getFieldValue("MBI").length;
    let SubscriberID = this.props.form.getFieldValue("SubscriberID").length;
    let LastName = this.props.form.getFieldValue("LastName").length;
    let FirstName = this.props.form.getFieldValue("FirstName").length;
    // let DOS = this.props.form.getFieldValue("DOS") == null ? 0 : this.props.form.getFieldValue("DOS").length
    let DOS =
      this.props.form.getFieldValue("DOS") == null ||
      this.props.form.getFieldValue("DOS") == ""
        ? 0
        : 1;
    let DateOfBirth =
      this.props.form.getFieldValue("DateOfBirth") == null ||
      this.props.form.getFieldValue("DateOfBirth") == ""
        ? 0
        : 1;
    // if(sessionStorage.getItem("planName") === 'ultimate'){
    if (
      SubscriberID > 0 &&
      LastName == 0 &&
      FirstName == 0 &&
      DateOfBirth == 0 &&
      MBI == 0
    ) {
      // console.log('1')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
        },
        DateOfBirth: {
          errors: [new Error("")],
        },
      });
      notification.open({
        message: "Fields Required",
        description: "Please Enter Last Name or Date of birth",
      });
      return;
    }

    if (
      SubscriberID == 0 &&
      LastName == 0 &&
      FirstName == 0 &&
      DateOfBirth == 0 &&
      MBI == 0 &&
      DOS > 0
    ) {
      // console.log('1')
      this.props.form.setFields({
        LastName: {
          value: this.props.form.getFieldValue("LastName"),
          errors: null,
        },
        FirstName: {
          value: this.props.form.getFieldValue("FirstName"),
          errors: null,
        },
        MBI: {
          value: this.props.form.getFieldValue("MBI"),
          errors: null,
        },
        DateOfBirth: {
          errors: null,
          value: this.props.form.getFieldValue("DateOfBirth"),
        },
      });
      notification.open({
        description: "Use a search combination with DOS",
      });
      return;
    }

    if (
      FirstName > 0 &&
      LastName == 0 &&
      DateOfBirth == 0 &&
      SubscriberID == 0 &&
      MBI == 0
    ) {
      // console.log('2')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
        },
        DateOfBirth: {
          errors: [new Error("")],
        },
        MBI: {
          value: this.props.form.getFieldValue("MBI"),
          errors: null,
        },
        SubscriberID: {
          value: this.props.form.getFieldValue("SubscriberID"),
          errors: null,
        },
      });
      notification.open({
        message: "Fields Required",
        description: "Please Enter last name and date of birth",
      });
      return;
    }

    if (
      FirstName > 0 &&
      LastName == 0 &&
      DateOfBirth > 0 &&
      SubscriberID == 0 &&
      MBI == 0
    ) {
      // console.log('2')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
        },
        DateOfBirth: {
          errors: null,
          value: this.props.form.getFieldValue("DateOfBirth"),
        },
        MBI: {
          value: this.props.form.getFieldValue("MBI"),
          errors: null,
        },
        SubscriberID: {
          value: this.props.form.getFieldValue("SubscriberID"),
          errors: null,
        },
      });

      notification.open({
        message: "Fields Required",
        description: "Please enter last name",
      });
      return;
    }

    if (
      FirstName > 0 &&
      LastName > 0 &&
      DateOfBirth == 0 &&
      SubscriberID == 0 &&
      MBI == 0
    ) {
      // console.log('3')
      this.props.form.setFields({
        LastName: {
          errors: null,
          value: this.props.form.getFieldValue("LastName"),
        },
        FirstName: {
          errors: null,
          value: this.props.form.getFieldValue("FirstName"),
        },
        DateOfBirth: {
          errors: [new Error("")],
        },
        SubscriberID: {
          errors: null,
          value: this.props.form.getFieldValue("SubscriberID"),
        },
        MBI: {
          errors: null,
          value: this.props.form.getFieldValue("MBI"),
        },
      });
      notification.open({
        message: "Fields Required",
        description: "Please Enter Date of birth",
      });
      return;
    }

    if (
      DateOfBirth > 0 &&
      MBI == 0 &&
      FirstName == 0 &&
      LastName == 0 &&
      SubscriberID == 0
    ) {
      // console.log('4 Only DOB')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("LastName"),
        },
        FirstName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("FirstName"),
        },
        SubscriberID: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("SubscriberID"),
        },
        DateOfBirth: {
          errors: null,
          value: this.props.form.getFieldValue("DateOfBirth"),
        },
        MBI: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("MBI"),
        },
      });
      notification.open({
        message: "Fields Required",
        description: "Please Enter any of the required field",
      });
      return;
    }

    if (
      LastName > 0 &&
      DateOfBirth > 0 &&
      SubscriberID == 0 &&
      FirstName == 0 &&
      MBI == 0
    ) {
      // console.log('Firstname and DOB ')
      this.props.form.setFields({
        FirstName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("FirstName"),
        },
        LastName: {
          errors: null,
          value: this.props.form.getFieldValue("LastName"),
        },
        SubscriberID: {
          errors: null,
          value: this.props.form.getFieldValue("SubscriberID"),
        },
        DateOfBirth: {
          errors: null,
          value: this.props.form.getFieldValue("DateOfBirth"),
        },
        MBI: {
          errors: null,
          value: this.props.form.getFieldValue("MBI"),
        },
      });
      notification.open({
        message: "Fields Required",
        description: "Please Enter First Name",
      });
      return;
    }

    if (
      MBI > 0 &&
      FirstName == 0 &&
      LastName == 0 &&
      DateOfBirth == 0 &&
      SubscriberID == 0
    ) {
      // console.log('5 only MBI')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("LastName"),
        },
        DateOfBirth: {
          value: this.props.form.getFieldValue("DateOfBirth"),
          errors: [new Error("")],
        },
      });
      notification.open({
        message: "Fields Required",
        description: "Please Enter Last Name or Date of birth",
      });
      return;
    }

    if (
      LastName > 0 &&
      FirstName == 0 &&
      SubscriberID == 0 &&
      FirstName == 0 &&
      DateOfBirth == 0 &&
      MBI == 0
    ) {
      // console.log('6 only last name')
      this.props.form.setFields({
        FirstName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("FirstName"),
        },
        DateOfBirth: {
          value: this.props.form.getFieldValue("DateOfBirth"),
          errors: [new Error("")],
        },
        MBI: {
          value: this.props.form.getFieldValue("MBI"),
          errors: [new Error("")],
        },
        SubscriberID: {
          value: this.props.form.getFieldValue("SubscriberID"),
          errors: [new Error("")],
        },
      });
      notification.open({
        message: "Fields Required",
        description: "Please Enter any of the required fields",
      });
      return;
    }

    this.props.form.setFields({
      LastName: {
        value: this.props.form.getFieldValue("LastName"),
        errors: null,
      },
      FirstName: {
        value: this.props.form.getFieldValue("FirstName"),
        errors: null,
      },
      DateOfBirth: {
        value: this.props.form.getFieldValue("DateOfBirth"),
        errors: null,
      },
      MBI: {
        value: this.props.form.getFieldValue("MBI"),
        errors: null,
      },
      SubscriberID: {
        value: this.props.form.getFieldValue("SubscriberID"),
        errors: null,
      },
      DOS: {
        value: this.props.form.getFieldValue("DOS"),
        errors: null,
      },
    });

    // } else {
    //   let DateOfServe = this.props.form.getFieldValue("DOS") == null || this.props.form.getFieldValue("DOS") == '' ? 0 : 1
    //   if(DateOfServe < 1){
    //     this.props.form.setFields({
    //       DOS: {
    //         errors: [new Error("")],
    //       }})
    //     }
    // }
    this.props.form.validateFields(async (err, values) => {
      values.DateOfBirth = values.DateOfBirth
        ? dayjs(values.DateOfBirth).format("MM/DD/YYYY")
        : "";
      values.MBI = values.MBI == "" ? null : values.MBI;
      values.SubscriberID =
        values.SubscriberID == "" ? null : values.SubscriberID;
      values.FirstName = values.FirstName == "" ? null : values.FirstName;
      values.LastName = values.LastName == "" ? null : values.LastName;
      values.DOS = values.DOS ? dayjs(values.DOS).format("MM/DD/YYYY") : "";
            // Get values from sessionStorage
      const roleName = sessionStorage.getItem("rolename");
      const planName = sessionStorage.getItem("planName"); 

      // If Plan is NOT solis → always null
      if (planName !== "solis") {
        values.PcpNpi = null;
      }
      else {
         // existing logic (UNCHANGED)
        if (roleName && roleName.includes("Provider")) {
          const providerNpi = JSON.parse(sessionStorage.getItem("npivalue") || "[]");
          values.PcpNpi = providerNpi.length ? providerNpi.join(",") : null;
        }
        else {
          const taxidNpiMapping = JSON.parse(sessionStorage.getItem("taxidNpiMapping")) || [];

          const npis = taxidNpiMapping
            .flatMap(item => item.NPI || [])
            .filter(npi => npi);

          values.PcpNpi = npis.length ? npis.join(",") : null;
        }
      }

      if (
        values.SubscriberID == "" &&
        values.LastName == "" &&
        values.FirstName == "" &&
        values.MBI == "" &&
        values.DateOfBirth == "" &&
        values.DOS == ""
      ) {
        this.openNotification();
      } else {
        if (!err) {
          this.setState({
            loader: true,
            Dummytable: "",
          });
          if (values.DOS == "" || values.DOS == null) {
            values.DOS = dayjs(new Date()).format("MM/DD/YYYY");
          }
          let data = await fetch(Config.api + "/GetMemberEligibilityCheck", {
            method: "POST",
            headers: {
              Authorization: sessionStorage.getItem("access_token"),
              Accept: "application/json",
              "Content-type": "application/json",
            },
            body: JSON.stringify({
              SearchParameter: values,
              PlanName: sessionStorage.getItem("planName"),
              IsDSNP: sessionStorage.getItem("IsDSNP"),
            }),
            // body: JSON.stringify(values),
          });
          data = await data.json();
          this.setState({
            clicked: true,
            Dummytable: data.MemberEligibilityDetails,
          });
          if (data.MemberEligibilityDetails.length > 0) {
            this.setState({
              headers: Object.keys(data.MemberEligibilityDetails[0]).map(
                (key) => {
                  return {
                    title: key,
                    displayName: Config.eligibilitytable[key].displayName,
                    display:
                      Config.eligibilitytable &&
                      Config.eligibilitytable[key] &&
                      Config.eligibilitytable[key].display
                        ? true
                        : false,
                    filterType:
                      Config.eligibilitytable[key].filterType || "text",
                  };
                }
              ),
              Dummytable: data.MemberEligibilityDetails,
              loader: false,
              // MemberDetails: data.MemberDetails,
            });
          } else {
            this.setState({
              loader: false,
            });
          }
        }
      }
    });
  };

  // sorting table data for each column................
  tableSortresult = (column) => {
    const direction = this.state.sort.direction === "desc" ? "asc" : "desc";
    const sortedData = this.state.Dummytable.sort((a, b) => {
      if (
        column === "SubscriberID" ||
        column === "FirstName" ||
        column === "LastName" ||
        column === "MBI" ||
        column === "Gender" ||
        column === "DateOfBirth" ||
        column === "PCPName" ||
        column === "EffectiveDate" ||
        column === "TerminationDate"
      ) {
        const nameA =
          column === "SubscriberID"
            ? a.SubscriberID.toUpperCase()
            : column === "FirstName"
            ? a.FirstName === null
              ? ""
              : a.FirstName.toUpperCase()
            : column === "LastName"
            ? a.LastName === null
              ? ""
              : a.LastName.toUpperCase()
            : column === "MBI"
            ? a.MBI === null
              ? ""
              : a.MBI.toUpperCase()
            : column === "Gender"
            ? a.Gender === null
              ? ""
              : a.Gender.toUpperCase()
            : column === "DateOfBirth"
            ? a.DateOfBirth === null
              ? ""
              : a.DateOfBirth
            : column === "PCPName"
            ? a.PCPName === null
              ? ""
              : a.PCPName.toUpperCase()
            : column === "EffectiveDate"
            ? a.EffectiveDate === null
              ? ""
              : a.EffectiveDate
            : a.TerminationDate === null
            ? ""
            : a.TerminationDate;
        const nameB =
          column === "SubscriberID"
            ? b.SubscriberID.toUpperCase()
            : column === "FirstName"
            ? b.FirstName === null
              ? ""
              : b.FirstName.toUpperCase()
            : column === "LastName"
            ? b.LastName === null
              ? ""
              : b.LastName.toUpperCase()
            : column === "MBI"
            ? b.MBI === null
              ? ""
              : b.MBI.toUpperCase()
            : column === "Gender"
            ? b.Gender === null
              ? ""
              : b.Gender.toUpperCase()
            : column === "DateOfBirth"
            ? b.DateOfBirth === null
              ? ""
              : b.DateOfBirth
            : column === "PCPName"
            ? b.PCPName === null
              ? ""
              : b.PCPName.toUpperCase()
            : column === "EffectiveDate"
            ? b.EffectiveDate === null
              ? ""
              : b.EffectiveDate
            : b.TerminationDate === null
            ? ""
            : b.TerminationDate;

        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      } else {
        return a.column - b.column;
      }
    });

    if (direction === "asc") {
      sortedData.reverse();
    }

    this.setState({
      Dummytable: sortedData,
      sort: {
        column,
        direction,
      },
    });
  };

  ClearTextFiled = () => {
    // console.log('ClearTextFiled ran')
    // this.props.form.resetFields();
    this.props.form.setFields({
      FirstName: {
        errors: null,
        value: "",
      },
      LastName: {
        errors: null,
        value: "",
      },
      DateOfBirth: {
        value: null,
        errors: null,
      },
      MBI: {
        value: "",
        errors: null,
      },
      SubscriberID: {
        value: "",
        errors: null,
      },
      DOS: {
        value: "",
        errors: null,
      },
    });
    this.setState({
      Dummytable: "",
      Geticon: false,
      clicked: false,
      loader: false,
    });
  };

  validaInputFields = (e) => {
    // console.log(DOS)
    // console.log(this.props.form.getFieldValue("DOS"))
    let MBI =
      this.props.form.getFieldValue("MBI") == undefined ||
      this.props.form.getFieldValue("MBI") == null
        ? 0
        : this.props.form.getFieldValue("MBI").length;
    let SubscriberID = this.props.form.getFieldValue("SubscriberID").length;
    let LastName = this.props.form.getFieldValue("LastName").length;
    let FirstName = this.props.form.getFieldValue("FirstName").length;
    // let DOS = this.props.form.getFieldValue("DOS") == null ? 0 : this.props.form.getFieldValue("DOS").length
    let DOS =
      this.props.form.getFieldValue("DOS") == null ||
      this.props.form.getFieldValue("DOS") == ""
        ? 0
        : 1;
    let DateOfBirth =
      this.props.form.getFieldValue("DateOfBirth") == null ||
      this.props.form.getFieldValue("DateOfBirth") == ""
        ? 0
        : 1;

    // console.log(DOS)
    if (
      !MBI &&
      !SubscriberID &&
      !LastName &&
      !FirstName &&
      !DOS &&
      !DateOfBirth
    ) {
      this.setState({
        Geticon: false,
      });
      this.ClearTextFiled();
    }
    if (DOS > 0) {
      this.setState({
        Geticon: true,
      });
      // this.ClearTextFiled();
    }

    // if (sessionStorage.getItem("planName") === "ultimate") {
    if (
      SubscriberID > 0 &&
      LastName == 0 &&
      FirstName == 0 &&
      DateOfBirth == 0 &&
      MBI == 0
    ) {
      // console.log('1')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
        },
        DateOfBirth: {
          errors: [new Error("")],
        },
      });
      return;
    }

    if (
      SubscriberID == 0 &&
      LastName == 0 &&
      FirstName == 0 &&
      DateOfBirth == 0 &&
      MBI == 0 &&
      DOS > 0
    ) {
      // console.log('1')
      this.props.form.setFields({
        LastName: {
          value: this.props.form.getFieldValue("LastName"),
          errors: null,
        },
        FirstName: {
          value: this.props.form.getFieldValue("FirstName"),
          errors: null,
        },
        MBI: {
          value: this.props.form.getFieldValue("MBI"),
          errors: null,
        },
        DateOfBirth: {
          errors: null,
          value: this.props.form.getFieldValue("DateOfBirth"),
        },
      });
      notification.open({
        description: "Use a search combination with DOS",
      });
      return;
    }

    if (
      FirstName > 0 &&
      LastName == 0 &&
      DateOfBirth == 0 &&
      SubscriberID == 0 &&
      MBI == 0
    ) {
      // console.log('2')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
        },
        DateOfBirth: {
          errors: [new Error("")],
        },
        MBI: {
          value: this.props.form.getFieldValue("MBI"),
          errors: null,
        },
        SubscriberID: {
          value: this.props.form.getFieldValue("SubscriberID"),
          errors: null,
        },
      });

      // notification.open({
      //   message: "Fields Required",
      //   description: "Please Enter last name and date of birth"
      // });
      return;
    }

    if (
      FirstName > 0 &&
      LastName == 0 &&
      DateOfBirth > 0 &&
      SubscriberID == 0 &&
      MBI == 0
    ) {
      // console.log('2')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
        },
        DateOfBirth: {
          errors: null,
          value: this.props.form.getFieldValue("DateOfBirth"),
        },
        MBI: {
          value: this.props.form.getFieldValue("MBI"),
          errors: null,
        },
        SubscriberID: {
          value: this.props.form.getFieldValue("SubscriberID"),
          errors: null,
        },
      });

      // notification.open({
      //   message: "Fields Required",
      //   description: "Please Enter last name and date of birth"
      // });
      return;
    }

    if (
      FirstName > 0 &&
      LastName > 0 &&
      DateOfBirth == 0 &&
      SubscriberID == 0 &&
      MBI == 0
    ) {
      // console.log('3')
      this.props.form.setFields({
        LastName: {
          errors: null,
          value: this.props.form.getFieldValue("LastName"),
        },
        FirstName: {
          errors: null,
          value: this.props.form.getFieldValue("FirstName"),
        },
        DateOfBirth: {
          errors: [new Error("")],
        },
        SubscriberID: {
          errors: null,
          value: this.props.form.getFieldValue("SubscriberID"),
        },
        MBI: {
          errors: null,
          value: this.props.form.getFieldValue("MBI"),
        },
      });
      // notification.open({
      //   message: "Fields Required",
      //   description: "Please Enter Date of birth",
      // });
      return;
    }

    if (
      DateOfBirth > 0 &&
      MBI == 0 &&
      FirstName == 0 &&
      LastName == 0 &&
      SubscriberID == 0
    ) {
      // console.log('4 Only DOB')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("LastName"),
        },
        FirstName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("LastName"),
        },
        SubscriberID: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("SubscriberID"),
        },
        DateOfBirth: {
          errors: null,
          value: this.props.form.getFieldValue("DateOfBirth"),
        },
        MBI: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("MBI"),
        },
      });
      // notification.open({
      //   message: "Fields Required",
      //   description: "Please Enter any of the required field",
      // });
      return;
    }

    if (
      LastName > 0 &&
      DateOfBirth > 0 &&
      SubscriberID == 0 &&
      FirstName == 0 &&
      MBI == 0
    ) {
      // console.log('Firstname and DOB ')
      this.props.form.setFields({
        FirstName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("FirstName"),
        },
        LastName: {
          errors: null,
          value: this.props.form.getFieldValue("LastName"),
        },
        SubscriberID: {
          errors: null,
          value: this.props.form.getFieldValue("SubscriberID"),
        },
        DateOfBirth: {
          errors: null,
          value: this.props.form.getFieldValue("DateOfBirth"),
        },
        MBI: {
          errors: null,
          value: this.props.form.getFieldValue("MBI"),
        },
      });
      // notification.open({
      //   message: "Fields Required",
      //   description: "Please Enter First Name",
      // });
      return;
    }

    if (
      MBI > 0 &&
      FirstName == 0 &&
      LastName == 0 &&
      DateOfBirth == 0 &&
      SubscriberID == 0
    ) {
      // console.log('5 only MBI')
      this.props.form.setFields({
        LastName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("LastName"),
        },
        DateOfBirth: {
          value: this.props.form.getFieldValue("DateOfBirth"),
          errors: [new Error("")],
        },
      });
      return;
    }

    if (
      LastName > 0 &&
      FirstName == 0 &&
      SubscriberID == 0 &&
      FirstName == 0 &&
      DateOfBirth == 0 &&
      MBI == 0
    ) {
      // console.log('6 only last name')
      this.props.form.setFields({
        FirstName: {
          errors: [new Error("")],
          value: this.props.form.getFieldValue("FirstName"),
        },
        DateOfBirth: {
          value: this.props.form.getFieldValue("DateOfBirth"),
          errors: [new Error("")],
        },
        MBI: {
          value: this.props.form.getFieldValue("MBI"),
          errors: [new Error("")],
        },
        SubscriberID: {
          value: this.props.form.getFieldValue("SubscriberID"),
          errors: [new Error("")],
        },
      });
      return;
    }

    this.props.form.setFields({
      LastName: {
        value: this.props.form.getFieldValue("LastName"),
        errors: null,
      },
      FirstName: {
        value: this.props.form.getFieldValue("FirstName"),
        errors: null,
      },
      DateOfBirth: {
        value: this.props.form.getFieldValue("DateOfBirth"),
        errors: null,
      },
      MBI: {
        value: this.props.form.getFieldValue("MBI"),
        errors: null,
      },
      SubscriberID: {
        value: this.props.form.getFieldValue("SubscriberID"),
        errors: null,
      },
      DOS: {
        value: this.props.form.getFieldValue("DOS"),
        errors: null,
      },
    });
    // }
  };

  getValue = (e, field = null) => {
    if (field == "DOB_Field") {
      // console.log('DOB_Field')
      this.props.form.setFieldsValue(
        {
          DateOfBirth: e,
        },
        (e) => {
          this.validaInputFields(e);
        }
      );
    } else if (field == "DOS_Field") {
      // console.log('DOS_Field')
      this.props.form.setFieldsValue({ DOS: e }, (e) => {
        this.validaInputFields(e);
      });
    } else {
      this.props.form.setFieldsValue(
        { [e.target.name]: e.target.value },
        (e) => {
          // console.log(this.props.form.getFieldValue("SubscriberID"))
          this.validaInputFields(e);
        }
      );
    }
    this.setState({
      Geticon: true,
    });
  };

  openNotification = () => {
    notification.open({
      message: "Notification Title",
      description: "Please Enter atleast one parameter !",
    });
  };
  componentDidMount() {
    const isCSNPPending =
      localStorage.getItem("IsCSNPPending") === "true" &&
      localStorage.getItem("IsCSNPPendingPopupActive") === "true";
  
    const isSSBCIPending =
      localStorage.getItem("IsSSBCIPending") === "true" &&
      localStorage.getItem("IsSSBCIPendingPopupActive") === "true";
  
    const isSolisPlan = sessionStorage.getItem("planName") === "solis";
  
    // Show modal if either CSNP or SSBCI is pending for solis plan
    if ((isCSNPPending || isSSBCIPending) && isSolisPlan) {
      let pendingText = "";

      if (isCSNPPending && isSSBCIPending) {
        pendingText = " You have Pending CSNP and SSBCI";
      } else if (isCSNPPending) {
        pendingText = "You have Pending CSNP";
      } else if (isSSBCIPending) {
        pendingText = "You have Pending SSBCI";
  }
      this.setState({ isModalVisible: true ,
        pendingtext: pendingText
      });
    }
  }

  handleOk = () => {
    this.setState({ isModalVisible: false });
    localStorage.setItem('IsCSNPPendingPopupActive',false);
    localStorage.setItem('IsSSBCIPendingPopupActive',false);    
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    let userName = sessionStorage.getItem("userName");
    return (
      <div>
        <WelcomePopup/>
        <div class="square-blue">
          <Row
            className="ml-4"
            type="flex"
            justify-content="space-start"
            align="middle"
            style={{ padding: "10px" }}
          >
            <Col>
              <div
                style={{ color: "white", fontSize: "18px", fontWeight: "bold" }}
              >
                <img src={skills} /> Member Search
              </div>
              <div style={{ color: "white" }}>
                Enter Details to check the Eligibility of Members
              </div>
            </Col>
            <Col push={13}>
              <div
                style={{ color: "white", fontSize: "18px", fontWeight: "bold" }}
              >
                User : {userName != null ? userName : ""}
              </div>
              {/* <div style={{ color: "white" }}>
                Total Members : {this.state.Dummytable.length}
              </div> */}
            </Col>
          </Row>
        </div>
        {/* <br/> */}

        <div className="square-white ml-4">
          <Row className="mt-3">
          {sessionStorage.getItem("IsDSNP") === "0" && (
                          <div className="pl-2 providerSearchBar" style={{ fontWeight: "bold",  marginTop: "-5px" }}>
                            <span>
                                  <span style={{ fontSize: "1.0em" }}>
                                    <InfoCircleTwoTone />
                                  </span>{" "}
                                <span style={{ color: "#0080FF" }}>
                                    This is a filtered list as the user is not authorized to see DSNP Records.
                                </span>
                              <span style={{ color: "red" }}>**</span>
                              </span>
                          </div>
                       )}
            {this.state.currState != this.state.cardstate && (
              <div>
                <Form onSubmit={this.SearchEpisode} className="searchMember">
                  <Row>
                    <Col span={4} className="pl-2">
                      <Col
                        className="ml-1"
                        style={{ color: "#464F5D", fontWeight: "600" }}
                      >
                        Subscriber ID
                      </Col>
                      <Form.Item>
                        {getFieldDecorator("SubscriberID", {
                          initialValue: "",
                        })(
                          <Input
                            name="SubscriberID"
                            onChange={(e) => this.getValue(e)}
                            size="medium"
                            placeholder="Enter Subscriber ID"
                            style={{
                              borderTop: "none",
                              borderRight: "None",
                              borderLeft: "none",
                            }}
                          />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={4} className="pl-4">
                      <Col
                        className="ml-1"
                        style={{ color: "#464F5D", fontWeight: "600" }}
                      >
                        MBI
                      </Col>
                      <Form.Item>
                        {getFieldDecorator("MBI", {
                          initialValue: "",
                        })(
                          <Input
                            name="MBI"
                            onChange={(e) => this.getValue(e)}
                            size="medium"
                            placeholder="Enter MBI"
                            style={{
                              borderTop: "none",
                              borderRight: "None",
                              borderLeft: "none",
                            }}
                          />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={4} className="pl-4">
                      <Col style={{ color: "#464F5D", fontWeight: "600" }}>
                        Last Name
                      </Col>
                      <Form.Item>
                        {getFieldDecorator("LastName", {
                          initialValue: "",
                        })(
                          <Input
                            size="medium"
                            name="LastName"
                            onChange={(e) => this.getValue(e)}
                            placeholder="Enter Last Name "
                            style={{
                              borderTop: "none",
                              borderRight: "None",
                              borderLeft: "none",
                            }}
                          />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={4} className="pl-4">
                      <Col
                        className="ml-1"
                        style={{ color: "#464F5D", fontWeight: "600" }}
                      >
                        First Name
                      </Col>
                      <Form.Item>
                        {getFieldDecorator("FirstName", {
                          initialValue: "",
                        })(
                          <Input
                            size="medium"
                            name="FirstName"
                            onChange={(e) => this.getValue(e)}
                            placeholder="Enter First Name"
                            style={{
                              borderTop: "none",
                              borderRight: "None",
                              borderLeft: "none",
                            }}
                          />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={4} className="pl-4 mt-1">
                      <Col
                        className="ml-1"
                        style={{ color: "#464F5D", fontWeight: "600" }}
                      >
                        Date of Birth
                      </Col>
                      <Form.Item>
                        {getFieldDecorator("DateOfBirth", {
                          initialValue: "",
                        })(
                          <DatePicker
                            size="medium"
                            name="DateofBirth"
                            onChange={(e) => this.getValue(e, "DOB_Field")}
                            format={["MM/DD/YYYY", "MM-DD-YYYY", "MMDDYYYY"]}
                            placeholder="Select DOB"
                            className="ant-calendar-picker-input "
                          />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={4} className="pl-3 mt-1">
                      <Col
                        className="ml-1"
                        style={{ color: "#464F5D", fontWeight: "600" }}
                      >
                        Date of Service
                      </Col>
                      <Form.Item>
                        {getFieldDecorator("DOS", {
                          // rules: [
                          //   {
                          //     required: false,
                          //     message: "Field is Required !",
                          //   },
                          // ],
                          initialValue: "",
                        })(
                          <DatePicker
                            size="medium"
                            format={["MM/DD/YYYY", "MM-DD-YYYY", "MMDDYYYY"]}
                            name="DOS"
                            // onChange={(e) => this.getValue(e)}
                            onChange={(e) => this.getValue(e, "DOS_Field")}
                            placeholder="Select DOS"
                            className="ant-calendar-picker-input"
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <div>
                    {this.state.Geticon == true && (
                      <div
                        style={{ float: "right" }}
                        className="mt-4 mr-3 pt-2"
                      >
                        <button
                          className="ml-1 search-button clear-button-color"
                          onClick={this.ClearTextFiled}
                        >
                          <img src={clear} style={{ marginTop: "-3px" }} />
                        </button>
                        <button
                          className="ml-3 mb-2 search-button search-button-color"
                          htmlType="submit"
                          value="submit"
                        >
                          <img src={search} style={{ marginTop: "-2px" }} />
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>
            )}
          </Row>
        </div>

        <Row>
          <Col span={12} className="ml-4">
            <div style={{ marginTop: "-4vh" }}>
              {this.state.Dummytable.length > 0 && (
                <div
                  style={{ float: "left" }}
                  className="mt-2 pt-2 total-lenth"
                >
                  {this.state.Dummytable.length}{" "}
                  {this.state.Dummytable.length <= 1
                    ? "Member Found"
                    : "Members Found"}
                </div>
              )}
            </div>
            {/* <div style={{ marginTop: "-4vh" }}>Jaiswal</div> */}
          </Col>
        </Row>

        {this.state.loader == true ? (
          <div style={{ marginTop: "36vh", marginLeft: "46vw" }}>
            <Spin size="large" />
            <div style={{ marginLeft: "-6vw" }} className="search-sreen-text">
              Loading Table data...
            </div>
          </div>
        ) : (
          <div>
            <div className="pt-2 mb-1" style={{ marginTop: "-4vh" }}>
              {this.state.headers && this.state.Dummytable.length > 0 && (
                <MemberTable
                  tableData={this.state.Dummytable}
                  tableSort={this.tableSortresult}
                  headers={this.state.headers}
                />
              )}

              <div className="no-data-found" style={{ marginTop: "13vh" }}>
                {this.state.Dummytable.length == 0 &&
                  this.state.clicked == true && (
                    <div style={{ marginTop: "-110px" }}>
                      <img style={{ marginRight: "100px" }} src={nodata} />
                      <div className="npdata-text ml-4">
                        Please check the parameters again <br></br>
                        <span className="or">or</span> <br></br>Search with
                        different parameters
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div className="blank-screen-image">
              {this.state.Dummytable == "" &&
                this.state.clicked == false > 0 && (
                  <div style={{ marginTop: "-110px" }}>
                    <img src={blackscreen} />
                    <div className="search-sreen-text ml-5">
                      Enter Details and search to see the Results
                    </div>
                  </div>
                )}
            </div>
          </div>
        )}
        <Modal
          title={<div style={{ textAlign: "center", width: "100%" }}>Pending Attestations</div>}
          open={this.state.isModalVisible}
          onOk={this.handleOk}
          closable={false}   // 🔹 removes the cross icon
          footer={[
            <Button key="ok" type="primary" onClick={this.handleOk}>
              OK
            </Button>,
          ]}
          centered   
        >
          <div style={{ textAlign: "center", fontSize: "16px" }}>
            <p>{this.state.pendingtext}</p>
          </div>
        </Modal>
      </div>
    );
  }
}
export default Form.create({ name: "EligibilityCheck" })(EligibilityCheck);
